import { render, staticRenderFns } from "./v-flow.vue?vue&type=template&id=b1dcf620&scoped=true&"
import script from "./v-flow.vue?vue&type=script&lang=js&"
export * from "./v-flow.vue?vue&type=script&lang=js&"
import style0 from "./v-flow.vue?vue&type=style&index=0&id=b1dcf620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dcf620",
  null
  
)

export default component.exports